<template>
  <div>
    <eden-page-stats
      class="mt-0"
      :title="'Overview'"
      :loading="loading"
      :stats="stats"
      :show-periods="false"
    >
      <template slot="actions">
        <eden-periods
          class="mr-10"
          :loading="loading"
          :default-period="'today'"
          :show-custom-period="true"
          :custom-title="'Provisioned Orders for'"
          @set-period="getProvisionedOrders"
        />
        <eden-service-partners
          :loading="loading"
          :allow-all="true"
          :service-partner-name.sync="servicePartnerName"
          :service-partner-id.sync="servicePartnerId"
          :service="'cleaning'"
        />
      </template>
    </eden-page-stats>
    <provisioned-orders-view
      :loading="loading"
      :service="'cleaning'"
      :period="period"
      :orders="setProvisionedOrders"
      :orders-time="ordersTime"
      @confirmed="getProvisionedOrders({ period })"
    />
  </div>
</template>

<script>
import ProvisionedOrdersView from "@/components/ServiceOperations/ProvisionedOrders/ProvisionedOrdersView";

import { parseProvisionedOrders } from "../provisioned-orders.config";
import * as actions from "@/store/action-types";

export default {
  name: "ProvisionedOrdersCleaning",
  components: {
    ProvisionedOrdersView,
  },
  data() {
    return {
      loading: false,
      period: "today",
      periods: [
        "lastweek",
        "yesterday",
        "today",
        "tomorrow",
        "nexttwodays",
        "thisweek",
        "nextweek",
      ],
      custom: {
        from: null,
        to: null,
      },
      servicePartnerName: "all",
      servicePartnerId: "all",
      provisionedOrders: {
        all: {},
      },
      ordersTime: "",
    };
  },
  computed: {
    setProvisionedOrders() {
      return this.provisionedOrders[this.servicePartnerName].orders;
    },
    stats() {
      const { customers, orders, confirmed, edited, incomplete } =
        this.provisionedOrders[this.servicePartnerName];

      return [
        {
          label: "Total customers",
          figure: (customers && customers.length) || "-",
        },
        {
          label: "Total orders",
          figure: (orders && orders.length) || "-",
        },
        {
          label: "Orders confirmed",
          figure: orders && orders.length ? confirmed : "-",
        },
        {
          label: "Orders edited",
          figure: orders && orders.length ? edited : "-",
        },
        {
          label: "Orders  incomplete",
          figure: orders && orders.length ? incomplete : "-",
        },
      ];
    },
  },
  created() {
    this.getProvisionedOrders({
      period: this.period,
      from: this.custom.from,
      to: this.custom.to,
    });
  },

  methods: {
    getProvisionedOrders({ period, from, to }) {
      this.loading = true;
      const { start_date, end_date } = this.formatStartAndEndDate({
        period: this.period,
        from,
        to,
      });
      this.$store
        .dispatch(actions.GET_PROVISIONED_ORDERS, {
          service: "cleaning",
          start_date,
          end_date,
          from,
          to,
        })
        .then((response) => {
          const { status, data } = response.data;
          if (status) {
            this.period = period;
            this.provisionedOrders = parseProvisionedOrders(
              data,
              "cleaning",
            );
            this.ordersTime = new Date();
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.loading = false;
        });
    },
  },
};
</script>
